import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

// Update with actual paths to your images
import DrPoncePhoto from "../images/DrSoniaPonce.jpg";
import YeseniaPhoto from "../images/YeseniaPhoto.jpg";
import AmparoPhoto from "../images/AmparoPhoto.jpg";
import VeronicaPhoto from "../images/VeronicaPhoto.jpg";
import AlexandraPhoto from "../images/AlexandraPhoto.jpg";
import LisaMayPhoto from "../images/LisaMayPhoto.jpg";
import JorgePhoto from "../images/DrSoniaPonce.jpg";
import PaulPhoto from "../images/DrSoniaPonce.jpg";
import MonsePhoto from "../images/MonsePhoto.jpg";

const PageContainer = styled.div`
  font-family: "Noto Sans", sans-serif;
  max-width: 1100px;
  margin: 0 auto;
`;

const SectionTitle = styled.h1`
  text-align: center;
  margin: 0 0 16px 0;
  color: rgb(104 38 85);
  @media (max-width: 700px) {
  }
`;
const Paragraph = styled.p`
  max-width: 750px;
  margin: 10px auto;
  font-size: 16px;
  line-height: 1.6;
  text-align: center;
`;

const DrPicBioSection = styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: 700px) {
    display: block;
  }
`;

const DrSection = styled.div`
  text-align: center;
  margin: 60px auto;
  padding: 30px 20px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
`;

const DrPictureSection = styled.div`
  display: flex;
  align-items: center;
`;

const DrImage = styled.img`
  max-width: 250px;
  border-radius: 8%;
  border: 1px solid rgb(104 38 85);

  @media (max-width: 700px) {
    margin-bottom: 20px;
  }
`;

const DrName = styled.h2`
  font-size: 28px;
  margin: 12px 0 6px;
  color: rgb(104 38 85);
`;

const DrRole = styled.p`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: rgb(197 59 108);
`;

const DrBio = styled.p`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  text-align: left;
  max-width: 700px;
  padding: 0 20px;
  font-size: 15px;
  color: #333;
`;
const StaffGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
`;

const StaffCard = styled.div`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 20px;
  text-align: center;
`;

const StaffPhoto = styled.img`
  // width: 200px;
  // height: 200px;
  max-width: 250px;
  object-fit: cover;
  border-radius: 8%;
  border: 1px solid rgb(104 38 85);
  margin-bottom: 10px;
`;

const StaffName = styled.h3`
  font-size: 18px;
  margin: 0;
  color: rgb(104 38 85);
`;

const StaffRole = styled.p`
  font-weight: bold;
  color: rgb(197 59 108);
  margin-bottom: 8px;
`;

const StaffBio = styled.p`
  font-size: 14px;
  white-space: pre-line;
`;

const ThisIsUs: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContainer className="ThisIsUs">
      <SectionTitle>{t("team.title").toUpperCase()}</SectionTitle>
      <Paragraph>{t("team.mission.eng")}</Paragraph>
      <DrSection>
        <DrName>Dr. Sonia Ponce</DrName>
        <DrRole>{t("team.roles.founderDirector")}</DrRole>
        <DrPicBioSection>
          <DrPictureSection>
            <DrImage src={DrPoncePhoto} alt="Dr. Sonia Ponce" />
          </DrPictureSection>
          <DrBio>
            {t("team.ponce.bio.eng")
              .split("•")
              .filter(Boolean)
              .map((item: string, index: number) => {
                const [boldPart, ...rest] = item.split(":");
                return (
                  <p key={index}>
                    <strong>{boldPart.trim()}:</strong> {rest.join(":")}
                  </p>
                );
              })}
          </DrBio>
        </DrPicBioSection>
      </DrSection>

      <StaffGrid>
        <StaffCard>
          <StaffPhoto src={AmparoPhoto} alt="Amparo" />
          <StaffName>Amparo Valencia</StaffName>
          <StaffRole>{t("team.roles.officeManager")}</StaffRole>
          {/* <StaffBio>{t("team.amparo.bio")}</StaffBio> */}
        </StaffCard>

        <StaffCard>
          <StaffPhoto src={VeronicaPhoto} alt="Verónica" />
          <StaffName>Verónica Vega</StaffName>
          <StaffRole>{t("team.roles.leadMA")}</StaffRole>
          {/* <StaffBio>{t("team.veronica.bio")}</StaffBio> */}
        </StaffCard>

        <StaffCard>
          <StaffPhoto src={YeseniaPhoto} alt="Yesenia Keller" />
          <StaffName>Yesenia Keller</StaffName>
          <StaffRole>{t("team.roles.provider")}</StaffRole>
          {/* <StaffBio>{t("team.yesenia.bio")}</StaffBio> */}
        </StaffCard>

        <StaffCard>
          <StaffPhoto src={AlexandraPhoto} alt="Alexandra Valdez" />
          <StaffName>Alejandra Valdez</StaffName>
          <StaffRole>{t("team.roles.ma")}</StaffRole>
        </StaffCard>

        <StaffCard>
          <StaffPhoto src={MonsePhoto} alt="Monse" />
          <StaffName>Monse Perez</StaffName>
          <StaffRole>{t("team.roles.ma")}</StaffRole>
        </StaffCard>

        <StaffCard>
          <StaffPhoto src={LisaMayPhoto} alt="LisaMay Hollamon" />
          <StaffName>LisaMay Hollamon</StaffName>
          <StaffRole>{t("team.roles.echoTech")}</StaffRole>
        </StaffCard>

        {/* <StaffCard>
          <StaffPhoto src={JorgePhoto} alt="Jorge Bazua" />
          <StaffName>Jorge Bazua</StaffName>
          <StaffRole>{t("team.roles.echoTech")}</StaffRole>
        </StaffCard>

        <StaffCard>
          <StaffPhoto src={PaulPhoto} alt="Paul" />
          <StaffName>Paul</StaffName>
          <StaffRole>{t("team.roles.echoTech")}</StaffRole>
        </StaffCard> */}
      </StaffGrid>
    </PageContainer>
  );
};

export default ThisIsUs;
